var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectorListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 12,
    fill: "url(#paint0_linear_1_3175)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 59.5,
    height: 59.5,
    rx: 11.75,
    stroke: "#E6E6E6",
    strokeOpacity: 0.901961,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 17,
    y: 17,
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4018 7.66304C25.3722 8.63339 25.3722 10.2102 24.4018 11.0593L21.0056 14.4555L11.5447 4.99457L14.9409 1.59835C15.9113 0.627997 17.4881 0.627997 18.3371 1.59835L20.5204 3.78164L24.1592 0.142822L25.8574 1.84094L22.2185 5.47975L24.4018 7.66304ZM17.3668 14.6981L15.6687 13L12.2724 16.3962L9.72528 13.849L13.1215 10.4528L11.4234 8.75468L8.02716 12.1509L6.20776 10.4528L2.81153 13.849C1.84118 14.8194 1.84118 16.3962 2.81153 17.2452L4.99482 19.4285L0.143066 24.2803L1.84118 25.9784L6.69293 21.1266L8.87622 23.3099C9.84657 24.2803 11.4234 24.2803 12.2724 23.3099L15.6687 19.9137L13.9706 18.2156L17.3668 14.6981Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3175",
    x1: 2.21774,
    y1: 30,
    x2: 60.121,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7445FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62D9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectorListView);
export default __webpack_public_path__ + "static/media/connector-list-view.1a82ef0ce7e0adbef89e49d8a11277a4.svg";
export { ForwardRef as ReactComponent };